module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.totalPages > 1),
      expression: "data.totalPages>1"
    }],
    staticClass: "pagination",
    class: _vm.pagingClass,
    attrs: {
      "role": "navigation",
      "aria-label": "pagination"
    }
  }, [_c('ul', {
    staticClass: "pagination-list"
  }, [_c('li', [_c('a', {
    staticClass: "pagination-link pagination-first",
    attrs: {
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to first page"
    },
    on: {
      "click": _vm.onClickFirstPage
    }
  }, [_vm._v("\n        Первая\n      ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "pagination-previous",
    attrs: {
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to previous page"
    },
    on: {
      "click": _vm.onClickPreviousPage
    }
  }, [_vm._v("\n        Предыдущая\n      ")])]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', [_c('a', {
      staticClass: "pagination-link",
      class: {
        activepage: _vm.isPageActive(page.name)
      },
      attrs: {
        "disabled": page.isDisabled,
        "aria-label": ("Go to page number " + (page.name))
      },
      on: {
        "click": function($event) {
          return _vm.onClickPage(page.name)
        }
      }
    }, [_vm._v("\n        " + _vm._s(page.name) + "\n      ")])])
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "pagination-next",
    attrs: {
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to next page"
    },
    on: {
      "click": _vm.onClickNextPage
    }
  }, [_vm._v("\n        Следующая\n      ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "pagination-link pagination-last",
    attrs: {
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to last page"
    },
    on: {
      "click": _vm.onClickLastPage
    }
  }, [_vm._v("\n        Последняя\n      ")])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eab4f47"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/components/Paging.vue
// module id = 369
// module chunks = 42